import { Navigate, Route, Routes } from 'react-router-dom';
import { getShouldDisplaySeeding } from 'helpers';
import { useCurrentKitAndTinyAccount } from 'hooks/useCurrentKitAndTinyAccount';
import { ConditionsRoutes } from 'views/Results/Conditions/Conditions';
import { InsightsRoutes } from 'views/Results/Insights';
import { MicrobiomeRoutes } from 'views/Results/Microbiome/Microbiome';
import { SeedingRoutes } from 'views/Results/Seeding';

import Summary from './Summary/Summary';

export const ResultsReadyRoutes = () => {
  const { currentKit, currentKitId } = useCurrentKitAndTinyAccount();

  if (!currentKitId) {
    return <Navigate to='/results' replace />;
  }
  return (
    <Routes>
      <Route path='insights/*' element={<InsightsRoutes />} />
      <Route path='microbiome' element={<MicrobiomeRoutes />} />
      <Route path='conditions/*' element={<ConditionsRoutes />} />

      {currentKit && getShouldDisplaySeeding(currentKit) ? (
        <Route path='seeding' element={<SeedingRoutes />} />
      ) : null}
      <Route path={`/*`} element={<Summary />} />
    </Routes>
  );
};
